<template>
  <div>
    <select v-model="selectedContractor" class="form-control rounded-0 g-mb-25" @change="contractorSelected">
      <option
          v-for="contractor in allContractors"
          :value="contractor"
          :key="contractor.contractorId"
      >{{ contractor.contractorDescription }}
      </option>
    </select>
    <input type="text" class="form-control rounded-0 form-control-md" v-if="selectedContractor.contractorType == null"
           v-model="selectedContractor.contractorOther" @blur="contractorBlur"/>
  </div>
</template>

<script>
import VisitorSigninService from '../../services/visitorsigninservice';
import {nextTick, onMounted, ref, toRefs, watch} from 'vue';

export default {
  name: 'contractorlistinput',
  props: {
    farmId: String,
    initContractor: Object
  },
  emit: ['contractorSelected'],
  setup(props) {
    const {farmId, initContractor} = toRefs(props);

    const selectedContractor = ref({contractorId: null, contractorDescription: '', contractorType: '', contractorOther: ''});
    const allContractors = ref([]);
    const visitorSignInService = VisitorSigninService;

    const farmChanged = async () => {

      await loadContractors();

      //If the init contract has been selected, do we set it?
      if (initContractor.value != null) {
        selectedContractor.value = allContractors.value.find(c => c.contractorId == initContractor.value.contractorId);
        if (selectedContractor.value != null && selectedContractor.value.contractorId == null) {
          selectedContractor.value.contractorOther = initContractor.value.contractorOther;
        }
      }
    };

    //mounted
    const loadContractors = async () => {

      const contractorProjects = await visitorSignInService.fetchContractorProjects(farmId.value);
      const contractors = await visitorSignInService.fetchContractors();

      await nextTick(() => {
        allContractors.value.splice(0);
        if (contractorProjects !== undefined) {
          contractorProjects.forEach(s => {
            let contractor = Object.assign({}, {
              contractorId: s.contractorId,
              contractorDescription: s.name,
              contractorType: 'P'
            });
            allContractors.value.push(contractor);
          });
        }

        if (contractors !== undefined) {
          contractors.forEach(s => {
            let contractor = Object.assign({}, {
              contractorId: s.contractorId,
              contractorDescription: s.name,
              contractorType: 'C'
            });
            allContractors.value.push(contractor);
          });
        }

        allContractors.value.push({
          contractorId: null,
          contractorDescription: 'Other',
          contractorType: null,
          contractorOther: ''
        });

      });
    };

    watch(farmId, farmChanged);

    onMounted(loadContractors);

    return {
      allContractors,
      selectedContractor
    }
  },
  methods: {
    contractorSelected() {
      this.$emit('contractorSelected', this.selectedContractor);
    },
    contractorBlur() {
      this.$emit('contractorSelected', this.selectedContractor);
    }
  }
}
</script>